import { useEffect } from "react";
import { useSelector } from "react-redux";
import { getOktaLoginUrl } from "../redux/config";

function AuthenticatedRoute({ children }) {
  const authState = useSelector((state) => state.auth);
  const authReady = !authState.loading;
  const userEmail = authState.user?.email;

  useEffect(() => {
    if (authReady && !userEmail) {
      window.location.replace(getOktaLoginUrl());
    }
  }, [authReady, userEmail]);

  if (!authReady || !userEmail) {
    return null;
  }

  return children;
}

export default AuthenticatedRoute;
